import React from 'react'
import Moment from 'moment'
import { DATE_FORMAT } from '../../constants'

function IncidenciaDate({ date }) {
    return <p>{Moment(date).format(DATE_FORMAT)}</p>
}

export default IncidenciaDate
